<template src="@/templates/dashboard/charts/jobs.html"></template>

<script>
    import Note from 'vue-graph/src/widgets/note.js'
    import Legends from 'vue-graph/src/widgets/legends.js'
    import moment from 'moment'

    export default {
        name: "dashboardJobs",
        props: ['chartType', 'xAxisLabel', 'chartValues', 'legendName', 'noteHeader', 'showSpinner'],
        components: {
            Note, Legends
        },
        created() {
            this.setViewHeight();
        },
        watch: {
            showSpinner: function () {
            },
        },
        data() {
            return {
                yAxisMaxValue: 0
            }
        },
        methods: {
            dataFormat(a, b) {
                if (b > 0) {
                    return b;
                }
                else {
                    return a;
                }
            },
            financialYear(identifier) {

                let month = moment().format("M");
                let year = moment().format("Y");

                if (month < 7) {
                    if (identifier === 'Start') {
                        return year - 1;
                    }
                    else {
                        return year;
                    }
                }

                if (month < 13) {
                    if (identifier === 'Start') {
                        return year;
                    }
                    else {
                        return year + 1;
                    }
                }
            },
            setViewHeight() {
                this.chartHeight = (window.innerHeight - 290) / 2;
            }
        }
    }
</script>

<style scoped>
	.allGradsCursor >>> svg {
		background: #f5f7fa !important;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/Jobs.vue